import * as React from 'react'

import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';

 class SystemtabStrip extends React.Component {
    constructor(props:any) {
        super(props);

        this.state = {
            selected: 2,
            PrimaryKeyEncrypted: ''
        };
    }
    handleSelect = (e) => {
        this.setState({ selected: e.selected });
    }
    render() {
        return (
            <TabStrip selected={this.state.selected} onSelect={this.handleSelect}>
                <TabStripTab title="Patient Detail">
                    <p>Patient Detail</p>
                </TabStripTab>
                <TabStripTab title="Encounter">
                    <p>Encounter</p>
                </TabStripTab>
                <TabStripTab title="Reading & Reminders">
                    <p>Reading & Reminders</p>
                </TabStripTab>
                <TabStripTab title="Patient Files">
                    <p>Patient Files</p>
                </TabStripTab>
            </TabStrip >

        )
    }
}

export default SystemtabStrip;
